import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteCategoryApi, deleteEmailTemplate, getCategoriesApi, getEmailTemplate, IMG_URL } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setSelectedCategory, setSelectedEmailTemplate } from '../../redux/authModalSlice';
const EmailTemplatestable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedMailId, setSelectedMailId] = useState(null);
    const [viewTemplate, setViewTemplate] = useState([])
    const [emailLoading,setEmailLoading] = useState(false)
    const dispatch = useDispatch()


    const [itemsPerPage] = useState(10);



    const { user } = useSelector((state) => state.authModal);

    const [emailTemplates, setEmailTemplates] = useState();



    const fromCountry = user?.from;
    const toCountry = user?.to;


    const [loading, setLoading] = useState(false);




    const getEmailTemplates = async () => {
        setLoading(true);
        setEmailLoading(true);
        try {
            const data = await getEmailTemplate();
            setEmailTemplates(data)
            setEmailLoading(false)
        } catch (err) {
            console.error("Fetch Error:", err);
        } finally {
            setLoading(false);
            setEmailLoading(false);

        }
    };


    useEffect(() => {

        getEmailTemplates()


    }, [])



    console.log(emailTemplates?.emailTemplates)

    const emailData = emailTemplates?.emailTemplates



    const [searchQuery, setSearchQuery] = useState("");
    const filteredData = emailData?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentItems = filteredData?.slice(startIdx, startIdx + itemsPerPage);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


    function stripHtml(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    const handleConfirmDelete = async () => {
        if (!selectedMailId) return;

        setLoading(true);



        // const toastId = toast.loading("Deleting...");

        try {
            const data = await deleteEmailTemplate({ id: selectedMailId });
            getEmailTemplates()
            // getCategoriesData()

            // toast.success("Delted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong.",
                // { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }


    return (
      <>
        <div className="card basic-data-table">
          <div className="card-header d-flex flex-row justify-content-between align-items-center">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <form className="navbar-search">
                <input
                  type="text"
                  className="bg-base h-40-px w-auto"
                  name="search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
            </div>

            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <Link
                to={"/add-email-templates"}
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              >
                <Icon
                  icon="ic:baseline-plus"
                  className="icon text-xl line-height-1"
                />
                Create Email Template
              </Link>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive" style={{ minHeight: "50vh" }}>
              <table
                className="table basic-table mb-0"
                id="dataTable"
                // data-page-length={10}
              >
                <thead>
                  <tr>
                    <th scope="col">Title</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Message</th>
                    {/* <th scope="col">Image</th> */}

                    {/* <th scope="col">Publish</th> */}
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {emailLoading ? (
                    <tr>
                      <td colSpan="10" className="text-center py-20">
                        <div
                          className="spinner-border"
                          role="status"
                          style={{
                            color: "#243E85",
                            width: "2rem",
                            height: "2rem",
                            borderWidth: "0.3em",
                          }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : currentItems?.length > 0 ? (
                    currentItems?.map((email) => (
                      <tr key={email.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <h6 className="text-md mb-0 fw-medium flex-grow-1">
                              {email.title}
                            </h6>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <h6
                              className="text-md mb-0 fw-medium flex-grow-1 text-truncate text-nowrap overflow-hidden"
                              style={{ maxWidth: "200px" }} // You must set max-width for truncate to work
                            >
                              {email.subject}
                            </h6>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <h6
                              className="text-md mb-0 fw-medium flex-grow-1 text-truncate text-nowrap overflow-hidden"
                              style={{ maxWidth: "200px" }}
                            >
                              {stripHtml(email.message)}
                            </h6>
                          </div>
                        </td>

                        {/* <td>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src="assets/images/user-list/user-list1.png"
                                                    alt=""
                                                    className="flex-shrink-0 me-12 radius-8"
                                                />

                                            </div>
                                        </td> */}

                        <td>
                          <Link
                            onClick={() => setViewTemplate(email)}
                            data-bs-toggle="modal"
                            data-bs-target="#viewEmailTemplateModal"
                            className="w-32-px h-32-px me-8 bg-secondary-subtle text-secondary rounded-circle d-inline-flex align-items-center justify-content-center"
                          >
                            <Icon icon="lucide:eye" />
                          </Link>
                          <Link
                            to={"/add-email-templates"}
                            onClick={() =>
                              dispatch(setSelectedEmailTemplate(email))
                            }
                            className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          >
                            <Icon icon="lucide:edit" />
                          </Link>

                          <Link
                            onClick={() => setSelectedMailId(email.id)}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalEdit"
                            className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          >
                            <Icon icon="mingcute:delete-2-line" />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-16 text-muted">
                        No Email Templates found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {filteredData?.length > itemsPerPage && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                  {filteredData?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${
                          currentPage === index + 1
                            ? "bg-primary-600 text-white"
                            : "bg-primary-50 text-secondary-light"
                        } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModalEdit"
          tabIndex={-1}
          aria-labelledby="exampleModalEditLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                  Confirm Deletion
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24 text-center">
                <p className="mb-4 fs-6 text-secondary">
                  Are you sure you want to delete this item?
                </p>
                <div className="d-flex justify-content-center gap-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="viewEmailTemplateModal"
          tabIndex={-1}
          aria-labelledby="viewEmailTemplateLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content radius-16">
              <div className="modal-header border-bottom">
                <h1
                  className="modal-title fs-5 fw-bold"
                  id="viewEmailTemplateLabel"
                >
                  Email Template
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="modal-body ">
                {/* Header Info */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h6 className="mb-1 fw-semibold">
                      Subject:{" "}
                      <span className="text-dark">
                        {" "}
                        {viewTemplate?.subject || "No Subject"}
                      </span>
                    </h6>
                  </div>
                  {/* <small className="text-muted">{new Date().toLocaleString()}</small> */}

                  <small className="text-muted">
                    Title: {viewTemplate?.title || "N/A"}
                  </small>
                </div>

                {/* Message */}
                <div
                  className="border rounded p-3 bg-light mb-3 "
                  style={{ minHeight: "150px" }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        viewTemplate?.message || "<em>No message content</em>",
                    }}
                  />
                </div>

                {/* Attachment */}
                {viewTemplate?.image && (
                  <div className="mt-4">
                    <h6 className="fw-semibold mb-3 mt-4">Attachment:</h6>
                    <img
                      src={`${IMG_URL}/${viewTemplate.image}`}
                      alt="Email Attachment"
                      className="img-thumbnail"
                      style={{ maxHeight: "200px" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default EmailTemplatestable